import softIcon from "images/icons/icon-soft-plus.svg?raw"
import parse from "html-react-parser"

export default function PlusIcon() {
  return (
    <span className="svg-icon">{parse(softIcon)}</span>
  )
}
